import Button from "../../components/Button";
import React from "react";
const Alert = ({ msg, onClose}) =>
    <div className="react-confirm-alert-body">
        <p> {msg}</p>
        <br/>
        <div className="btn ok-2">
            <Button
                className="btn btn-primary start-5"
                onClickHandler={onClose}
            > Ok </Button>
        </div>
    </div>

export default Alert;